import React, { memo } from 'react'
import { TextInput } from 'components/atoms'

interface IAmountProps {
  id: string
  label: string
  value?: string | number
  onChange: (...args: any[]) => any
}
const Amount: React.FunctionComponent<IAmountProps> = memo(({ id, label, onChange, value }) => (
  <div className='col-xs-7'>
    <TextInput
      id={id}
      type='number'
      min='0'
      dataTest={id}
      label={label}
      value={value || ''}
      placeholder='Enter amount'
      onChange={onChange}
    />
  </div>
))

export default Amount
